import api from "../index";

export const CreateServiceApi = (data) => api.post("addupdateservicetype", data);
export const getAllServiceApi = () => api.post("servicetypelist");
export const getclientlist = (data) => api.post("getclientlist", data);
export const UpdateServiceApi = (data) => api.post("addupdateservicetype", data);
export const DeleteServiceApi = (data) => api.post("deleteservicecascade", data);
export const UpdateServiceStatusApi = (data) => api.post("statusupdateservicetype", data);
export const UpdateBookKeepingStatusApi = (data, headers) => api.post("update-bookkeeping-file-status", data, headers);

export const AddSectionApi = (data) => api.post("addupdatesection", data);
export const GetAllSectionsApi = (id) => api.post("servicesectionlist", id);
export const DeleteSectionApi = (data) => api.post("deleteservicecascade", data);
export const ReOrderSectionApi = (data) => api.post("reorderservicesection", data);

export const AddUpdateQuestionApi = (data) => api.post("addupdatequestion", data);
export const QuestionListApi = (data) => api.post("servicewisequestionlist", data);
export const DeleteQuestionApi = (data) => api.post("deleteservicecascade", data);
export const ReOrderQuestionApi = (data) => api.post("reordersectionquestions", data);

export const GetConditionalQuestionsApi = (data) => api.post("conditionquestionlist", data);

export const GetServiceTaskApi = (data) => api.post('servicetasklist', data);
export const GetTaskWiseFileApi = (data) => api.post('taskwisefile', data);
export const GetFileDetailsApi = (data) => api.post('file-details', data);
export const GetFileAnswerApi = (data) => api.post('filewiseanswerlist', data);
export const ReviewAnswerApi = (data) => api.post('answerreviewcheck', data);
export const GetFileNoteApi = (data) => api.post('filenoteslist', data);
export const EditFileNoteApi = (data) => api.post('addupdatefilenotes', data);
export const ReviewAllSectionApi = (data) => api.post('answerreviewcheck', data);
export const GetBookKeepingApi = (data) => api.post('bookkeeping-file-data', data);
export const GetBookKeepingDocumentApi = (data) => api.post('get-bookkeeping-document', data);

export const UnsubmitFileApi= (data) => api.post('unsubmitfile', data);
export const CompleteTaskApi= (data, headers) => api.post('updatefilesubmitstatus', data, headers);
export const SendInvoiceApi = (data) => api.post('send-invoice', data);
export const SendToSignApi = (data, headers) => api.post('send-to-sign', data, headers);
export const ExportFileApi = (data, headers) => api.post('export-service-file', data, headers);
export const ExportPdfFileApi = (data, headers) => api.post('export-service-pdf-file', data, headers);
export const SendToVerifyApi = (data, headers) => api.post('send-verify-doc', data, headers);

export const AssignTaskApi = (data) => api.post('assign-task', data);
export const GetEmployeeList = (data) => api.post('getemployeelist', data);


export const AddUpdateAnswerApi = (data) => api.post('addupdateanswer', data);